// extracted by mini-css-extract-plugin
export default {"content":"ooa-z","title":"poa-z","subTitle":"qoa-z","banner":"roa-z","productCardOverride":"soa-z"};